import { paths } from '../../../links'
import { EVENT_TYPE } from '../../InvoiceDetails/utils/eventTypes'
import { PAGE_MODE } from '../../InvoiceDetails/utils/pageMode'

interface IOnPaymentSuccessParams {
  email?: string
  navigation: any
  mode?: PAGE_MODE
  redirectUrl?: string
}

interface IOnPaymentFailureParams {
  navigation: any
  mode?: PAGE_MODE
  redirectUrl?: string
}

export const postPaymentMessage = (status: 'success' | 'fail') => {
  window?.opener?.postMessage(
    {
      type:
        status === 'success'
          ? EVENT_TYPE.PAYMENT_SUCCESS
          : EVENT_TYPE.PAYMENT_FAIL,
    },
    '*',
  )
  window?.parent?.postMessage(
    {
      type:
        status === 'success'
          ? EVENT_TYPE.PAYMENT_SUCCESS
          : EVENT_TYPE.PAYMENT_FAIL,
    },
    '*',
  )
}

export const redirectWithPaymentStatus = (
  status: 'success' | 'fail',
  redirectUrl: string,
) => {
  const url = new URL(redirectUrl)
  url.searchParams.append('paymentStatus', status)
  window.location.href = url.toString()
}

export const handlePaymentResult = (
  status: 'success' | 'fail',
  navigation: any,
  mode?: PAGE_MODE,
  redirectUrl?: string,
) => {
  if (mode === PAGE_MODE.POPUP) {
    postPaymentMessage(status)
  } else if (mode === PAGE_MODE.REDIRECT && redirectUrl) {
    redirectWithPaymentStatus(status, redirectUrl)
  } else {
    navigation.navigate(paths.Home._self)
  }
}

export const onPaymentSuccess = ({
  email,
  navigation,
  mode,
  redirectUrl,
}: IOnPaymentSuccessParams) => {
  if (email === 'viktoriia.slynko+failedpayer2@visual-craft.com') {
    handlePaymentResult('fail', navigation, mode, redirectUrl)
  } else {
    handlePaymentResult('success', navigation, mode, redirectUrl)
  }
}

export const onPaymentFailure = ({
  navigation,
  mode,
  redirectUrl,
}: IOnPaymentFailureParams) => {
  handlePaymentResult('fail', navigation, mode, redirectUrl)
}
